﻿import React from 'react';
import PropTypes from 'prop-types';

export default class CheckBox extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.props.onChange(val.target.checked);
    }

    render() {
        return (
            <div className={`custom-control custom-checkbox${this.props.inline ? " custom-control-inline": ""}`}>
                <input
                    role="checkbox"
                    aria-checked={this.props.checked}
                    type="checkbox"
                    id={this.props.id}
                    name={this.props.name}
                    className="custom-control-input"
                    checked={this.props.checked}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                />
                <label className="custom-control-label" htmlFor={this.props.id}>
                    {this.props.labelContent &&
                        this.props.labelContent
                    }
                    {this.props.label}</label>
            </div>
        );
    }
}

CheckBox.propTypes = {
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    labelContent: PropTypes.element
};